import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('PaymentFilter', PaymentFilterData);

    PaymentFilterData.$inject = ['PAYMENT'];

    /* @ngInject */
    function PaymentFilterData(PAYMENT) {
        PaymentFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            preparBeforeSearch: preparBeforeSearch,
            setPage: setPage,
            setPageSize: setPageSize,
            setSort: setSort,
            resetSort: resetSort,
        };

        function PaymentFilter(paymentFilterData) {
            if (!paymentFilterData) {
                this.buildEmpty();
            } else {
                this.build(paymentFilterData);
            }
        }

        return PaymentFilter;

        function buildEmpty() {
            this.eid = null;
            this.status = PAYMENT.status[0];
            this.reference = null;
            this.seller = null;
            this.sellerId = null;
            this.invoiceId = null;
            this.buyerType = PAYMENT.buyer_type[0];
            this.buyerId = null;
            this.createdDateFrom = null;
            this.createdDateTo = null;
            this.updatedDateFrom = null;
            this.updatedDateTo = null;
            this.amount = null;

            this.pageCriteria = {
                pageSize: PAYMENT.pagination.defaultPageSize,
                page: PAYMENT.pagination.defaultPage,
                sorts: PAYMENT.pagination.defaultSort,
            };
        }

        function build(paymentFilterData) {
            this.eid = paymentFilterData.eid || null;
            this.status = paymentFilterData.status;
            this.reference = paymentFilterData.reference || null;
            this.seller = paymentFilterData.seller || null;
            this.sellerId = paymentFilterData.sellerId || null;
            this.invoiceId = paymentFilterData.invoiceId || null;
            this.buyerType = paymentFilterData.buyerType || null;
            this.buyerId = paymentFilterData.buyerId || null;
            this.createdDateFrom = paymentFilterData.createdDateFrom || null;
            this.createdDateTo = paymentFilterData.createdDateTo || null;
            this.updatedDateFrom = paymentFilterData.updatedDateFrom || null;
            this.updatedDateTo = paymentFilterData.updatedDateTo || null;
            this.amount = paymentFilterData.amount || null;

            this.pageCriteria = {
                pageSize: paymentFilterData.pageSize || 20,
                page: paymentFilterData.page || 0,
                sorts: _setSort(paymentFilterData.sorts),
            };
        }

        function _setSort(sorts) {
            if (!sorts || sorts.length === 0) {
                return [
                    {
                        direction: 'ASC',
                        property: 'creationDate',
                    },
                ];
            }
            return sorts;
        }

        function preparBeforeSearch() {
            var clone = new PaymentFilter(this);
            clone.pageCriteria = this.pageCriteria;
            // on supprime le filtre si la valeur est 'Tous'
            if (clone.status.value === 'ALL') {
                clone.status = null;
            } else {
                clone.status = clone.status.value;
            }
            // on supprime le filtre si la valeur est 'Tous'
            if (clone.buyerType.value === 'ALL') {
                clone.buyerType = null;
            } else {
                clone.buyerType = clone.buyerType.value;
            }

            if (this.seller) {
                clone.sellerId = this.seller.sellerId;
                clone.seller = null;
            }
            return clone;
        }

        /**
         * Indiquer la page
         */
        function setPage(page) {
            this.pageCriteria.page = page;
        }

        /**
         * Changement de pagination
         */
        function setPageSize(pageSize) {
            this.pageCriteria.pageSize = pageSize;
        }

        /**
         * Mise à jour du tri (tri sur une seule colonne)
         */
        function setSort(sorts) {
            this.pageCriteria.sorts = sorts;
        }

        /**
         * Lorsqu'on ne souhaite aucun tri
         */
        function resetSort() {
            this.pageCriteria.sorts = [];
        }
    }
})();
